export default __webpack_public_path__ + "static/media/interior_gold.0307f66b.png";